import { queryClient } from 'index'
import { AccountStatusResponse } from 'services/api/endpoints/risikaAPI/accountStatus'

export const getAccountStatusData = () => {
  const status = queryClient.getQueriesData(
    'accountStatus'
  )?.[0]?.[1] as AccountStatusResponse
  return status
}
